'use strict';

/* eslint-disable @typescript-eslint/ban-types */
var EnvironmentTypeOptions = /*#__PURE__*/function (EnvironmentTypeOptions) {
  EnvironmentTypeOptions["MOCK"] = "mock";
  EnvironmentTypeOptions["NORMAL"] = "normal";
  EnvironmentTypeOptions["CLOUDMOCK"] = "cloudMock";
  EnvironmentTypeOptions["SYSTEM"] = "system";
  EnvironmentTypeOptions["SELF_HOSTED_MOCK"] = "SELF_HOSTED_MOCK";
  return EnvironmentTypeOptions;
}({});
var ImportType = /*#__PURE__*/function (ImportType) {
  ImportType["APP"] = "app";
  ImportType["POSTMAN"] = "postman";
  return ImportType;
}({});
var EnvironmentMockType = [EnvironmentTypeOptions.MOCK, EnvironmentTypeOptions.CLOUDMOCK, EnvironmentTypeOptions.SELF_HOSTED_MOCK];
var RegistrationCenterType = /*#__PURE__*/function (RegistrationCenterType) {
  RegistrationCenterType["EDAS"] = "edas";
  RegistrationCenterType["ZOOKEEPER"] = "zookeeper";
  RegistrationCenterType["NACOS"] = "nacos";
  return RegistrationCenterType;
}({});
exports.EnvironmentMockType = EnvironmentMockType;
exports.EnvironmentTypeOptions = EnvironmentTypeOptions;
exports.ImportType = ImportType;
exports.RegistrationCenterType = RegistrationCenterType;
